import CommonUtils from "@/resources/utils/common-utils";
import API from "@/config/api";

export default {
    state: {},
    mutations: {
        getBaseProgrammeList(state, data) {
            data.url = API.serviceCharge.getBaseProgramme;
            CommonUtils.GetRequest(data);
        },
        getProductList(state, data) {
            data.url = API.serviceCharge.getProductList;
            CommonUtils.GetRequest(data);
        },
        getInsuranceList(state, data) {
            data.url = API.serviceCharge.getInsuranceList;
            CommonUtils.GetRequest(data);
        },
        getProgrammeDetail(state, data) {
            data.url = API.serviceCharge.getProgrammeDetail;
            CommonUtils.GetRequest(data);
        },
        addProgramme(state, data) {
            data.url = API.serviceCharge.addProgramme;
            CommonUtils.PostRequest(data);
        },
        editProgramme(state, data) {
            data.url = API.serviceCharge.editProgramme;
            CommonUtils.PostRequest(data);
        },
        addCommissionContinued(state, data) {
            data.url = API.serviceCharge.addCommissionContinued;
            CommonUtils.PostRequest(data);
        },
        getCommissionContinuedList(state, data) {
            data.url = API.serviceCharge.getCommissionContinuedList;
            CommonUtils.GetRequest(data)
        },
        getCommissionContinuedDetail(state, data) {
            data.url = API.serviceCharge.getCommissionContinuedDetail;
            CommonUtils.GetRequest(data)
        },
        editCommissionContinueDetail(state, data) {
            data.url = API.serviceCharge.editCommissionContinueDetail;
            CommonUtils.PostRequest(data)
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/serviceCharge.js